import { Component, OnInit } from '@angular/core';
import { AdminMenuService } from '../../../services/admin-menu.services';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { moduloSeguridad } from '../../../diccionarios/seguridadModulo.js';
import { AdminMenu, ModeloAdminMenu, MantenerMenuGuardar } from '../../../models/adminMenu';
import { Router } from '@angular/router';
import { SesionService } from '../../../services/sesion.service';
import { SesionSeguridadModel } from '../../../models/sesionSeguridad.model';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';

@Component({
  selector: 'app-nivel3',
  templateUrl: './nivel3.component.html',
  styleUrls: ['./nivel3.component.css']
})
export class Nivel3Component implements OnInit {

  formulario: FormGroup;
  columnDefs: any[];
  rowData;
  frameworkComponents: any;
  rowSelection: any;
  gridApi: any;
  gridColumnApi: any;
  diccionarioModulo: any;
  modelo: ModeloAdminMenu;
  buscarListaSession: SesionSeguridadModel[];
  nivel3 = 3;
  enviarMenuSuperior = 3;
  descripcionMenuSuperior = '';
  descripcionMenuSuperiorNivel2 = '';
  cmbSesion: any[];
  abrir: any;
  enviarIdRegistro = 0;
  modoEdicion = false;
  mostrarFormulario = false;
  textBoton = '';
  cmbListAplicacion: any[];

  constructor(private servicioWeb: AdminMenuService,
    private fb: FormBuilder,
    private servicioUtils: UtilsService,
    private sesionServicio: SesionService,
    private router: Router) { }

  ngOnInit() {
    this.enviarMenuSuperior = Number(localStorage.getItem('enviarMenuSuperiorNivel2'));
    this.descripcionMenuSuperior = localStorage.getItem('descripcionMenuSuperior');
    this.descripcionMenuSuperiorNivel2 = localStorage.getItem('descripcionMenuSuperiorNivel2');
    this.diccionarioModulo = moduloSeguridad;
    const innclase = new AdminMenu();
    this.modelo = innclase.devolverModeloAdminMenu();
    this.getListaAplicacion();
    this.getAllNivel3();
    this.componentGrid();
    this.getAllSesiones();
    this.formulario = this.fb.group({
      sesionId: ['', [Validators.required]],
      descripcion: ['', [Validators.required]],
      application: [''],
      orden: ['', [Validators.required]]
    });
  }//end onInit

  getListaAplicacion() {
    this.sesionServicio.getAplicacion().subscribe((resp: any[]) => {
      this.cmbListAplicacion = resp.sort((a, b) => a.orden - b.orden);
    }, (err) => {
      console.log(err);
    });
  }//

  getAllSesiones() {
    this.sesionServicio.getAll().subscribe((res: any) => {
      this.cmbSesion = res;
      this.buscarListaSession = res;
    }, (err) => {
      console.log(err);
    });
  }

  getAllNivel3() {
    this.servicioWeb.getAllNivel(this.nivel3, this.enviarMenuSuperior).subscribe((resp: any[]) => {
      this.rowData = resp.sort((a, b) => a.orden - b.orden);
    }, (err) => {
      console.log(err);
    });
  }

  componentGrid() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'NIVEL',
        field: this.modelo.nivelDescrip,
        sortable: true,
        resizable: true,
        filter: true
      },
      {
        headerName: 'DESCRIPCION',
        field: this.modelo.descripcion,
        sortable: true,
        resizable: true,
        filter: true
      },
      {
        headerName: 'DESCRIPCION SESSION',
        field: this.modelo.sesionDescrip,
        sortable: true,
        resizable: true,
        filter: true,
        width: 450
      },
      {
        headerName: 'ORDEN',
        field: this.modelo.orden,
        sortable: true,
        resizable: true,
        filter: true,
        width: 130
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        // width: 150,
        cellRendererParams: {
          onClick: this.editarLinea.bind(this),
          label: this.diccionarioModulo.button.buttonsNombre.editar,
          colorBoton: this.diccionarioModulo.button.buttonsCss.success
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        cellRendererParams: {
          onClick: this.eliminarLinea.bind(this),
          label: this.diccionarioModulo.button.buttonsNombre.eliminar,
          colorBoton: this.diccionarioModulo.button.buttonsCss.danger
        }
      }
    ];
    this.rowSelection = 'multiple';
  }//end componentGri()

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  NuevoMenuNivel3() {
    const descripcion = this.formulario.get('descripcion').value;
    const sesionId = this.formulario.get('sesionId').value;
    const orden = this.formulario.get('orden').value;
    this.servicioUtils.confirmarSincronoPromesaNormal({
      title: '¿Esta seguro que desea guardar un nuevo Menu Nivel 3 \n(' + descripcion + ')?',
      text: '',
      action: '',
      funcion: this.servicioWeb.devolverObservableOk(descripcion)
    }).then((nuevaDescripcion: any) => {
      const llenarObjeto = new MantenerMenuGuardar(null, descripcion, orden, this.nivel3, sesionId, this.enviarMenuSuperior);
      this.guardarMenuNivel3(llenarObjeto);
    }).catch((err) => {
      console.log(err);
    });
  }

  guardarMenuNivel3(innObjeto) {
    this.servicioWeb.guardarMenu(innObjeto).subscribe((resp) => {
      this.servicioUtils.mensajeOKVisto(`Se creo el registro correctamente.`, true, 3000);
      this.mostrarGrid();
      this.getAllNivel3();
    }, (error) => {
      this.servicioUtils.mensajeErrorVisto(error.error.mensaje, true, 3000);
    });
  }

  editarLinea({ rowData }) {
    this.formulario.get('descripcion').setValue(rowData.descripcion);
    this.formulario.get('sesionId').setValue(rowData.sesionId);
    this.formulario.get('application').setValue(rowData.aplication);
    this.formulario.get('orden').setValue(rowData.orden);
    this.enviarIdRegistro = rowData.id;
    this.mostrarFormulario = true;
    this.modoEdicion = true;
    this.textBoton = this.diccionarioModulo.button.buttonsNombre.editar;
  }

  actualizarDatosServicios() {
    const descripcion = this.formulario.get('descripcion').value;
    const sesionId = this.formulario.get('sesionId').value;
    const orden = this.formulario.get('orden').value;
    this.servicioUtils.confirmarSincronoPromesaNormal({
      title: '¿Esta seguro que desea modificar el siguiente registro \n(' + descripcion + ')?',
      text: '',
      action: '',
      funcion: this.servicioWeb.devolverObservableOk(descripcion)
    }).then((nuevaDescripcion: any) => {
      const llenarObjeto = new MantenerMenuGuardar(this.enviarIdRegistro, descripcion, orden, this.nivel3, sesionId, this.enviarMenuSuperior);
      this.actualizarMenuNivel3(llenarObjeto);
    }).catch((err) => {
      console.log(err);
    });
  }

  actualizarMenuNivel3(innObjeto) {
    this.servicioWeb.actualizarMenu(innObjeto).subscribe((resp) => {
      this.mostrarGrid();
      this.getAllNivel3();
    }, (error) => {
      this.servicioUtils.mensajeErrorVisto(error.error.mensaje, true, 3000);
    });
  }

  mostrarGrid() {
    this.mostrarFormulario = false;
    this.modoEdicion = false;
  }

  eliminarMenuNivel3(innId) {
    this.servicioWeb.eliminarId(innId).subscribe((resp) => {
      this.gridApi.updateRowData({ remove: this.gridApi.getSelectedRows() });
    }, (error) => {
      this.servicioUtils.mensajeErrorVisto(error.error.mensaje, true, 3000);
    });
  }

  eliminarLinea({ rowData }) {
    this.servicioUtils.confirmarSincronoPromesaNormal({
      title: '¿Esta seguro que desea Eliminar un nuevo Menu Nivel 3 \n(' + rowData.descripcion + ')?',
      text: '',
      action: '',
      funcion: this.servicioWeb.devolverObservableOk(rowData.descripcion)
    }).then((nuevaDescripcion: any) => {
      this.eliminarMenuNivel3(rowData.id);
    }).catch((err) => {
      console.log(err);
    });
  }

  goNivel2() {
    this.router.navigate(['admin-seguridad/mantener-menu/2']);
  }

  nuevoMostrarModal() {
    this.formulario.reset();
    this.mostrarFormulario = true;
    this.modoEdicion = false;
    this.textBoton = this.diccionarioModulo.button.buttonsNombre.guardar;
  }

  acciones(event) {
    if (event === 'guardar') {
      if (this.modoEdicion) {
        this.actualizarDatosServicios();
      } else {
        this.NuevoMenuNivel3();
      }
    } else {
      this.mostrarGrid();
    }
  }

  changeAplicacion(target) {
    const posicion = target.options.selectedIndex;
    const nombre = target[posicion].text;
    this.cmbSesion = this.buscarListaSession.filter((item: any) => {
      if (item.application === nombre) {
        return item;
      }
    });
  }

}// end class
